import React from 'react';
import { useSelector } from 'react-redux';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { useAtomValue } from 'jotai';
import { errorResponseAtom } from '@src/components/metrics-panel-hz/atoms/index';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export const FILTER_ERROR = `This filter has issues.
    It could be because of error in filter logic or deleted dimensions.
    Please update the filter and try again`;

export const INAPPLICABLE_FILTER_ERROR = `The filter has been modified which not supported in the dashboard. Please check the filter.`;

export const FIlTER_CONTAINS_INAPPLICALBE_DIMENSION_ERROR =
  'The filter contains dimensions not applicable to this Dashboard. Please select any other filter';

export const useFilterErrorMsg = (filter: any) => {
  const { dataScope } = useSelector(activeDashboardSelector);
  if (dataScope) {
    const isSavedFilter = Boolean(filter?.fid);
    return isSavedFilter ? INAPPLICABLE_FILTER_ERROR : FIlTER_CONTAINS_INAPPLICALBE_DIMENSION_ERROR;
  }
  return FILTER_ERROR;
};

export const FilterStatus = ({ filterName, appliedFilter }) => {
  let filterError = false;
  const errorData = useAtomValue(errorResponseAtom) || {};
  appliedFilter.rule.forEach((rule) => {
    rule.forEach((r) => {
      if (errorData[r.field] === true) filterError = true;
    });
  });

  const errorMsg = useFilterErrorMsg(appliedFilter);
  return (
    <>
      {filterName}
      {filterError && (
        <Tooltip placement="right" title={errorMsg}>
          <ExclamationCircleOutlined style={{ color: '#ff2f36', marginLeft: 2 }} />
        </Tooltip>
      )}
    </>
  );
};
